module.exports = __webpack_public_path__ + "static/img/rank_275.0d171eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_275.png
// module id = kcXj
// module chunks = 1